<template>
	<div class="w1200">
		<br><br><br><br>
		<div class="notfound">
			<div class="nf-txt">哎呀，出错了！您访问的页面不存在......</div>
			<div class="nf-img">
				<img src="../assets/images/404.png" />
			</div>
			<div class="nf-txt">您可以通过以下方式继续访问：</div>
			<div class="nf-btn">
				<a href="/">访问首页</a>
			</div>
			<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue